export var main_btn_update = {
    key: 'user_profile::main_btn_update',
    fallback: "Update"
};
export var main_lbl_currentPassword = {
    key: 'user_profile::main_lbl_currentPassword',
    fallback: "Current Password"
};
export var main_lbl_dateFormat = {
    key: 'user_profile::main_lbl_dateFormat',
    fallback: "Date Format"
};
export var main_lbl_email = {
    key: 'user_profile::main_lbl_email',
    fallback: "Email Address"
};
export var main_lbl_firstName = {
    key: 'user_profile::main_lbl_firstName',
    fallback: "First Name"
};
export var main_lbl_formatPreview = {
    key: 'user_profile::main_lbl_formatPreview',
    fallback: "Format Preview"
};
export var main_lbl_language = {
    key: 'user_profile::main_lbl_language',
    fallback: "Language"
};
export var main_lbl_lastName = {
    key: 'user_profile::main_lbl_lastName',
    fallback: "Last Name"
};
export var main_lbl_newPassword = {
    key: 'user_profile::main_lbl_newPassword',
    fallback: "New Password"
};
export var main_lbl_numberFormat = {
    key: 'user_profile::main_lbl_numberFormat',
    fallback: "Number Format"
};
export var main_lbl_repeatPassword = {
    key: 'user_profile::main_lbl_repeatPassword',
    fallback: "Repeat New Password"
};
export var main_localizationDateFormatOption_groupCommaDecimalDot = {
    key: 'user_profile::main_localizationDateFormatOption_groupCommaDecimalDot',
    fallback: "Thousands separator: comma. Decimal separator: period"
};
export var main_localizationDateFormatOption_groupDotDecimalComma = {
    key: 'user_profile::main_localizationDateFormatOption_groupDotDecimalComma',
    fallback: "Thousands separator: period. Decimal separator: comma"
};
export var main_localizationDateFormatOption_groupSpaceDecimalComma = {
    key: 'user_profile::main_localizationDateFormatOption_groupSpaceDecimalComma',
    fallback: "Thousands separator: space. Decimal separator: comma"
};
export var main_localizationDateFormatOption_groupSpaceDecimalDot = {
    key: 'user_profile::main_localizationDateFormatOption_groupSpaceDecimalDot',
    fallback: "Thousands separator: space. Decimal separator: period"
};
export var main_localizationPreview_numbers = {
    key: 'user_profile::main_localizationPreview_numbers',
    fallback: "Numbers"
};
export var main_localizationPreview_shortDate = {
    key: 'user_profile::main_localizationPreview_shortDate',
    fallback: "Short Date"
};
export var main_msgError_wrongPassword = {
    key: 'user_profile::main_msgError_wrongPassword',
    fallback: "Oops, that\u2019s the wrong password!"
};
export var main_msgSuccess_detailsUpdated = {
    key: 'user_profile::main_msgSuccess_detailsUpdated',
    fallback: "Details updated successfully"
};
export var main_title_changePassword = {
    key: 'user_profile::main_title_changePassword',
    fallback: "Change Password"
};
export var main_title_localizationSettings = {
    key: 'user_profile::main_title_localizationSettings',
    fallback: "Language and Locale Settings"
};
export var main_title_userDetails = {
    key: 'user_profile::main_title_userDetails',
    fallback: "User Details"
};
